import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import { AuctionItem, AuctionItemState, DateUtilsService } from 'remarketing-angular-library';
import { takeUntil } from 'rxjs/operators';
import { CurrencyFormatService, SaComponent } from 'smartauction-frontend-micro-library';
import { AuctionBadgeComponent, DatalistItemComponent } from 'remarketing-ui-components-lib';


@Component({
    selector: 'app-auto-vision-auction-detail',
    templateUrl: './auto-vision-auction-detail.component.html',
    styleUrls: ['./auto-vision-auction-detail.component.scss'],
    imports: [AuctionBadgeComponent, DatalistItemComponent]
})
export class AutoVisionAuctionDetailComponent extends SaComponent implements OnInit {
  auctionItem: AuctionItem;

  autoVisionAuctionDetailTranslations = {
    textOpeningPrice: '',
    currentBid: '',
    tooltipLowestPriceMetaTitle: '',
    tooltipLowestPriceTitle: '',
    tooltipLowestPriceBody: '',
    lowestPrice: '',
    salePrice: '',
    spreadToBook: '',
    spreadToBookMetaTitle: '',
    spreadToBookTitle: '',
    spreadToBookBody: '',
    offerListTooltipBody: '',
    startDateTime: '',
    distanceUnit: '',
    saleDateTime: '',
    posted: '',
    msrp: '',
    tenantBadge: '',
    partOf: '',
    sharedList: '',
    sold: ''
  };

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly currencyFormatService: CurrencyFormatService,
    private readonly dateUtilService: DateUtilsService,
    private readonly store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
    this.setAuctionItem();
  }

  localizeDate(date) {
    return this.dateUtilService.localizeDateAndTime(date, true);
  }

  formatCurrency(currency) {
    return this.currencyFormatService.formatCurrency(currency, false).replaceAll('-', '');
  }

  setAuctionItem() {
    this.store.select(AuctionItemState.auctionItem).subscribe(response => {
      this.auctionItem = response;
    });
  }

  getTranslations() {
    const keyParams = {
      'sellModule.details.auctionDetail': {},
      'common': {},
      'sellModule.details.auctionDetail.tooltipSpreadToBook': {},
      'vehicles.recentActivity.soldData': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        translate => {
          this.autoVisionAuctionDetailTranslations.textOpeningPrice = translate[0].textOpeningPrice;
          this.autoVisionAuctionDetailTranslations.currentBid = translate[0].currentBid;
          this.autoVisionAuctionDetailTranslations.tooltipLowestPriceMetaTitle = translate[0].tooltipLowestPrice.metaTitle;
          this.autoVisionAuctionDetailTranslations.tooltipLowestPriceTitle = translate[0].tooltipLowestPrice.title;
          this.autoVisionAuctionDetailTranslations.tooltipLowestPriceBody = translate[0].tooltipLowestPrice.body;
          this.autoVisionAuctionDetailTranslations.spreadToBook = translate[0].spreadToBook;
          this.autoVisionAuctionDetailTranslations.startDateTime = translate[0].startDateTime;
          this.autoVisionAuctionDetailTranslations.saleDateTime = translate[0].saleDateTime;
          this.autoVisionAuctionDetailTranslations.salePrice = translate[0].salePrice;
          this.autoVisionAuctionDetailTranslations.posted = translate[0].posted;
          this.autoVisionAuctionDetailTranslations.msrp = translate[0].msrp;
          this.autoVisionAuctionDetailTranslations.tenantBadge = translate[0].tenantBadge;
          this.autoVisionAuctionDetailTranslations.distanceUnit = translate[1].distanceUnit;
          this.autoVisionAuctionDetailTranslations.spreadToBookMetaTitle = translate[2].metaTitle;
          this.autoVisionAuctionDetailTranslations.spreadToBookTitle = translate[2].title;
          this.autoVisionAuctionDetailTranslations.spreadToBookBody = translate[2].body;
          this.autoVisionAuctionDetailTranslations.sold = translate[3].sold;
        },
        error => {
          console.log(error);
        }
      );
  }
}
